import { createContext, useContext, ReactNode } from 'react';
import { useSessionState} from '../hooks/useSessionState';

// Define the shape of the context data
export type SessionContextType = ReturnType<typeof useSessionState>;

// Create the context with a default value of null
export const SessionContext = createContext<SessionContextType | null>(null);

export const SessionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const sessionState = useSessionState();

  return (
    <SessionContext.Provider value={sessionState}>
      {children}
    </SessionContext.Provider>
  )
};

// Custom hook for consuming the context
export const useSession = (): SessionContextType => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};